import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    width: '100%',

    '& .appointment-column-loading': {
      display: 'flex',
      flexGrow: 1,
      width: '100%',
      height: '100%',
      borderRight: `solid 1px ${theme.palette.divider}`,
    },

    '& .slider-appointments': {
      display: 'flex',
      flexGrow: 1,
      width: '100%',
    },
  },
}));

export default styles;
